<template>
  <el-dialog title="手动发放" :visible.sync="visible" :close-on-click-modal="false" width="620px" :before-close="close">
    <div>
      <p>
        <strong>优惠券名称：</strong>
        <span>{{ defaultTips(form.couponTicketName) }}</span>
      </p>
      <p>
        <strong>剩余(张)：</strong>
        <span>{{ defaultTips(form.remainderUpQuantity) }}</span>
      </p>
      <p>
        <strong>通知渠道：</strong>
        <el-checkbox-group v-model="form.checkList">
          <el-checkbox disabled label="邮件" />
          <el-checkbox disabled label="站内信" />
        </el-checkbox-group>
      </p>
      <p>
        <strong class="release">发放客户：</strong>
        <el-input v-model="form.textarea" type="textarea" :rows="6" resize="none" placeholder="请输入邮箱/手机号，多个换行分隔，不可超过剩余数量或50个" />
      </p>
    </div>

    <div v-if="checkEmailResult.passable.length || checkEmailResult.cannot.length">
      <p>
        <strong>可添加邮箱/手机号数量：</strong>
        <el-popover placement="bottom" width="620" trigger="click">
          <div>{{ defaultTips(checkEmailResult.passable.join('，')) }}</div>
          <span slot="reference" class="success">{{ defaultTips(checkEmailResult.passable.length) }}</span>
        </el-popover>
      </p>
      <p>
        <strong>不可添加的邮箱/手机号：</strong>
        <span class="error">{{ defaultTips(checkEmailResult.cannot.join('，')) }}</span>
      </p>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">取消</el-button>
      <el-button :disabled="form.textarea ? false : true" size="medium" type="warning" @click="checkEmails">检验邮箱/手机号</el-button>
      <el-button :disabled="isCheckEmail" :loading="loading" size="medium" type="primary" @click="save">确定发放</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
import uniq from 'lodash/uniq'

export default {
  data() {
    return {
      visible: false,

      form: {
        id: undefined,
        couponTicketName: undefined,
        remainderUpQuantity: 0,
        checkList: [],
        textarea: undefined,
        users: []
      },

      loading: false, // 确定按钮加载效果
      isCheckEmail: true, // 是否启用提交按钮（是否已校验邮箱）
      checkEmailResult: {
        cannot: [], // 不可添加的邮箱
        passable: [] // 可以添加的邮箱
      }
    }
  },
  watch: {
    'form.textarea'() {
      this.isCheckEmail = true
    }
  },
  computed: {
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * API 手动发放优惠券
     */
    async manuallyIssueCouponTickets(query) {
      let { data, code, message } = await API.manuallyIssueCouponTickets(query)
      if (code === 10000) {
        this.close()
        this.$emit('update')
        this.$message.success(`本次成功发放 ${data} 位客户，详情可到“已领取”页面查看`)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * API 获取邮箱是否注册
     */
    async emailRegisterInfo(emails) {
      let { data, code, message } = await API.emailRegisterInfo(emails)
      if (code === 10000) {
        return data
      } else {
        this.$message.error(message)
        return []
      }
    },

    /**
     * 显示对话框
     *
     * @param {Object} paylod 传输的数据
     */
    show(paylod) {
      this.visible = true
      if (paylod && paylod instanceof Object) {
        this.form.id = paylod.id
        this.form.couponTicketName = paylod.couponTicketName
        this.form.remainderUpQuantity = paylod.remainderUpQuantity
      }
    },

    /**
     * 关闭对话框
     */
    close() {
      this.clear()
      this.visible = false
    },

    /**
     * 解析文本域中的邮箱为数组形式
     *
     * @return {Array} 解析后得到的数组
     */
    analysis() {
      let emails = []
      if (this.form.textarea && this.form.textarea.trim()) {
        emails = this.form.textarea.trim().split(/[\r\n]+/)
        if (emails.length) {
          emails = uniq(emails.map((item) => item.trim()))
        }
      }
      return emails
    },

    /**
     * 校验用户输入的邮箱/手机号是否存在
     */
    async checkEmails() {
      let emails = this.analysis()
      let result = await this.emailRegisterInfo(emails)
      if (result.length) {
        let passable = result.map((item) => ({ email: item.email, phone: item.phone }))
        if (passable.length) {
          this.isCheckEmail = false
        } else {
          this.isCheckEmail = true
        }
        this.checkEmailResult.cannot = emails.filter((item) => !passable.some(e => e.email === item || e.phone === item)) // 不可添加的邮箱/手机号 // !passable.includes(item)
        this.checkEmailResult.passable = [...passable] // 可以添加的邮箱
        this.form.users = [...result.map((item) => item.userId)]
      } else {
        this.form.users = []
        this.$message.warning('无符合条件的邮箱/手机号！')
      }
    },

    /**
     * 确定按钮的回调事件：
     * 1.输入的邮箱个数不能超过剩余数量或者50个。
     * 2.需要校验用户输入的客户邮箱是否存在。
     */
    async save() {
      if (this.checkQuantity()) {
        if (this.form.users.length) {
          this.manuallyIssueCouponTickets({ id: this.form.id, userIds: this.form.users })
        }
      }
    },

    /**
     * 负责检查用户输入的邮箱是否超出剩余数量或者大于50
     *
     * @return {Boolean} 是否校验通过
     */
    checkQuantity() {
      let emails = this.analysis()
      if (this.form.remainderUpQuantity <= 50) {
        if (emails.length > this.form.remainderUpQuantity) {
          this.$message.warning('客户数量不能大于剩余数量！')
          return false
        } else {
          return true
        }
      } else {
        if (emails.length > 50) {
          this.$message.warning('最大客户数量不能大于50个！')
          return false
        } else {
          return true
        }
      }
    },

    /**
     * 负责对话框关闭时清除数据
     */
    clear() {
      this.loading = false
      this.isCheckEmail = true
      this.checkEmailResult = {
        cannot: [],
        passable: []
      }
      Object.keys(this.form).forEach((key) => {
        if (['checkList', 'users'].includes(key)) {
          this.form[key] = []
        } else {
          this.form[key] = undefined
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-checkbox-group {
  display: inline-block;
}

p {
  margin-bottom: 15px;
  .release {
    display: inline-block;
    margin-bottom: 5px;
  }
}

.el-textarea {
  display: block;
}

.success {
  color: #99c41c;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.error {
  color: #f56c6c;
}
</style>
